import { sanitizeEditorCanvasHtml } from '../../../helpers/sanitize-editor-canvas-html';

/**
 * Set innerHTML for editor canvas views after sanitizing datasource/widget HTML.
 * Does not execute embedded scripts (unsafe in the editor and inconsistent with save output).
 */
export function setInnerHTML(elm: HTMLElement, html: string) {
  elm.innerHTML = sanitizeEditorCanvasHtml(html, elm.ownerDocument?.defaultView ?? null);
}

/**
 * Legacy behavior: assign raw HTML and re-create script tags so they execute.
 * Avoid in editor canvas; prefer {@link setInnerHTML} with sanitization.
 */
export function setInnerHTMLAndRunScripts(elm: HTMLElement, html: string) {
  elm.innerHTML = html;
  Array.from(elm.querySelectorAll('script')).forEach(oldScript => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
    oldScript?.parentNode?.replaceChild(newScript, oldScript);
  });
}
